import { SurveyCakeLogicEngine } from '@surveycake/logic-engine';
import { useEngineInstance } from '@surveycake/react-logic-engine';
import { useDidMount } from '@surveycake/rhooks';
import { getCount } from 'app/core/http';
import { useSurveyConfig } from 'app/core/survey-config';
import { useTracker } from 'app/core/tracker';
import { ReCaptcha } from 'app/modules/reCAPTCHA';
import { removeLoading } from 'app/shared/utils/removeLoading';
import { enterprise } from 'config/system';
import { decode } from 'he';
import { useState } from 'react';

function setTitle(title: string) {
  let resolvedTitle = decode(title);

  if (!enterprise.is) {
    resolvedTitle = `${resolvedTitle} » SurveyCake`;
  }

  document.title = resolvedTitle;
}

async function initialEngineModules(engine: SurveyCakeLogicEngine) {
  try {
    await Promise.all([ReCaptcha.initial(engine)]);
  } catch (error) {
    throw error;
  }
}

export function useInitialEngine() {
  const surveyConfig = useSurveyConfig();
  const engine = useEngineInstance();
  const tracker = useTracker();
  const [isInitialed, setIsInitialed] = useState(false);

  useDidMount(async () => {
    const {
      surveyHash,
      tempAnswerHash: answerHash,
      data,
      answers,
      meta,
      subjects,
      query,
      referral,
      serverTime,
      translation
    } = surveyConfig;

    setTitle(data.title!);

    try {
      await engine.init({
        surveyHash,
        answerHash,
        data,
        meta,
        subjects,
        query,
        referral,
        initime: serverTime,
        resolver: {
          count: getCount
        },
        translation,
        answers,
      });
      await initialEngineModules(engine);
      setIsInitialed(true);
      removeLoading();
      tracker.trackSurveyRendered('index');
    } catch (error) {
      /**
       * Directly throw error to devtools.
       */
      throw error;
    }
  });

  return isInitialed;
}
